import { Component } from '@angular/core';
import { SettingsMenuService } from '@app/modules/settings/services/settings-menu.service';

@Component({
    templateUrl: './company-logo-show.template.html',
    styleUrls: ['./company-logo-show.style.scss'],
})
export class CompanyLogoShowView {
    constructor(public settingsMenuService: SettingsMenuService) {}
}
